import React, { Component } from 'react';
import { API } from 'aws-amplify';
import Chart from "react-apexcharts";
import { Dimmer } from "tabler-react";
class GraficaCalificaciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            series: [],
            labels: [],
            isLoading: true,
            curso: []
        };
    }
    componentDidMount = () => {
        this.getInfoCalificaciones();
    }

    obtenerCalificacionesPorMatricula = (matricula, calificacionesPorActividad) => {
        let alumnos = []
        for (let calificaciones of calificacionesPorActividad) {
            if (calificaciones.matricula === matricula) {
                alumnos.push(calificaciones);
            }
        }
        return alumnos;
    }
    obtieneCalificacionPorActividad = (idActividad, actividadesAlumno) => {
        let calificacion = 0;
        for (let actividad of actividadesAlumno) {
            if (actividad.actividadesId === idActividad) {
                if (actividad.calificacionFinal){
                    calificacion = actividad.calificacionFinal;
                }
            }
        }
        return calificacion;
    }
    obtieneNombreAlumnoPorMatricula = (matricula, alumnos) => {
        let nombre = "";
        for (let alumno of alumnos) {
            if (alumno.matricula === matricula) {
                nombre = alumno.nombres;
            }
        }
        return nombre;
    }
    getInfoCalificaciones = async () => {
        try {

            const docenteInfo = JSON.parse(localStorage.getItem('profile'));
            let cursosData = [];
            let alumnosData = [];
            let matriculasData = [];
            let actividades = [];
            // let alumnos = []; 
            const respuestaApiCursos = await API.post('apiMisCursos', '/obtenerFinalGrades', {body: { nivel: this.props.data.nivel, username: docenteInfo.username, cursoUnico: this.props.data.cursosNombres, tipo: "cursos" } } )
            
            if(respuestaApiCursos.status) {
                Array.prototype.push.apply(cursosData, respuestaApiCursos.data.cursos);
            }
            const respuestaApiAlumnos= await API.post('apiMisCursos', '/obtenerFinalGrades', {body: { nivel: this.props.data.nivel, username: docenteInfo.username, tipo: "alumnos" } } )
            if(respuestaApiAlumnos.status) {
                let infoAlumno = respuestaApiAlumnos.data.alumnos
                let alumnosFinal = [];
                let matriculasFinal = [];
                let actividadesFinal = [];
                let calificacionesActividadesFinal = []; 
                for (const alumnosInfo of infoAlumno) {
                    if(alumnosInfo.cursoNombre == this.props.data.cursosNombres ){
                        alumnosFinal.push(alumnosInfo)
                        matriculasFinal.push(alumnosInfo.matricula)
                    }
                }
                Array.prototype.push.apply(alumnosData, alumnosFinal);
                Array.prototype.push.apply(matriculasData, matriculasFinal );
                
                const respuestaApiActividades = await API.post('apiMisCursos', '/obtenerFinalGrades', {body: { nivel: this.props.data.nivel, username: docenteInfo.username, cursoUnico: this.props.data.cursosId, tipo: "actividades" } } )
                if(respuestaApiActividades.status){
                    let actividad = respuestaApiActividades.data.actividadesInfo
                    for (const actividadInfo of actividad) {
                        actividadesFinal.push(actividadInfo.idActividad)
                    }
                    Array.prototype.push.apply(actividades, respuestaApiActividades.data.actividadesInfo );
                }
                if (matriculasFinal.length >= 50) {
                    let arregloDeArreglos = []; // Aquí almacenamos los nuevos arreglos
                    const LONGITUD_PEDAZOS = 25; // Partir en arreglo de 3
                    for (let i = 0; i < matriculasFinal.length; i += LONGITUD_PEDAZOS) {
                        let pedazo = matriculasFinal.slice(i, i + LONGITUD_PEDAZOS);
                        arregloDeArreglos.push(pedazo);
                    }
                    for (const arreglo of arregloDeArreglos) {
                        const respuestaApiCalificaciones = await API.post('apiMisCursos', '/obtenerFinalGrades', {body: { nivel: this.props.data.nivel, username: docenteInfo.username, cursoNombre: this.props.data.cursosNombres, cursoId: this.props.data.cursosId, matriculas: arreglo, actividadesRevisar: actividadesFinal, tipo: "calificaciones" } } )
                        if(respuestaApiCalificaciones.status) {
                            let resultCalificaicones = respuestaApiCalificaciones.data.calificacionesActividades;
                            for (const calificaciones of resultCalificaicones) {
                                calificacionesActividadesFinal.push(calificaciones) 
                            }
                        }
                    }

                } else {
                    const respuestaApiCalificaciones = await API.post('apiMisCursos', '/obtenerFinalGrades', {body: { nivel: this.props.data.nivel, username: docenteInfo.username, cursoNombre: this.props.data.cursosNombres, cursoId: this.props.data.cursosId, matriculas: matriculasFinal, actividadesRevisar: actividadesFinal, tipo: "calificaciones" } } )
                    Array.prototype.push.apply(calificacionesActividadesFinal, respuestaApiCalificaciones.data.calificacionesActividades );

                }
                let data = {alumnos: alumnosData, cursos: cursosData, matricula: matriculasData, actividadesInfo: actividades, calificacionesActividades: calificacionesActividadesFinal};
                
                let alumnosCurso = [];
                let matriculasCurso = [];
                let count = 0;
    
                for (let indexAlumnos in data.alumnos) {
                    if (this.props.data.cursosNombres === data.alumnos[indexAlumnos].cursoNombre) {
                        alumnosCurso.push(data.alumnos[indexAlumnos]);
                        matriculasCurso.push(data.alumnos[indexAlumnos].matricula);
                        count++;
                    }
                }
                // if (respuestaApiCalificaciones.status) {
                    let calificacionesPorActividad = data.calificacionesActividades;
                    let actividadesInfo = data.actividadesInfo;
                    // let alumnosInfo = respuestaApi.data.alumnos;
                    let alumnosInfo = alumnosCurso;
                    // let matriculas = data.matriculas;
                    let matriculas = matriculasCurso;
                    let cursos = data.cursos;
                    let series = [];
                    let labels = [];
                    for (let matricula of matriculas) {
                        // Obtenemos solo la matrícula actual 
                        let alumnos = this.obtenerCalificacionesPorMatricula(matricula, calificacionesPorActividad, cursos);
                        let calificacionesAlumnoActividad = [];
                        let nombreAlumno = this.obtieneNombreAlumnoPorMatricula(matricula, alumnosInfo);
                        for (let actividad of actividadesInfo) {
                            if (actividad.idCurso === this.props.data.cursosId){
                                if (labels.includes(actividad.nombreActividad) === false) {labels.push(actividad.nombreActividad)}
                                let calificacion = this.obtieneCalificacionPorActividad(actividad.idActividad, alumnos);
                                calificacionesAlumnoActividad.push(calificacion)
                            }
                        }
                        series.push({name: nombreAlumno, data: calificacionesAlumnoActividad})
                        //{name: 'Carmen Maria', data: [25, 25, 25, 15]}
                    }
                    this.setState({series: series, labels: labels, isLoading: false})
                // } 
            }
            
        } catch (e) {}
        
    }
    render() {
        return (
            
            <div className="GraficaCalificaciones">
                <div className="row">
                    <div className="mixed-chart">
                        <Dimmer loader active={this.state.isLoading}>
                        <Chart
                            series={this.state.series}
                            options={{
                                chart: {
                                    type: 'heatmap',
                                    toolbar: { show: false }
                                },
                                plotOptions: {
                                    heatmap: {
                                        shadeIntensity: 0.7,
                                        radius: 0,
                                        colorScale: {
                                            ranges: [{
                                                    from: 0,
                                                    to: 5,
                                                    name: '',
                                                    color: '#ff0000'
                                                },
                                                {
                                                    from: 6,
                                                    to: 16,
                                                    name: '',
                                                    color: '#ff9500'
                                                },
                                                {
                                                    from: 14,
                                                    to: 18,
                                                    name: '',
                                                    color: '#b3ff00'
                                                },
                                                {
                                                    from: 19,
                                                    to: 45,
                                                    name: '',
                                                    color: '#00A100'
                                                }
                                            ]
                                        }
                                    }
                                },
                                dataLabels: {
                                    enabled: true
                                },
                                labels: this.state.labels,
                                legend: {
                                    show: false
                                }
                            }}
                            type="heatmap"
                            width="100%"
                            height="755"
                        />
                        </Dimmer>
                    </div>
                </div>
            </div>
        );
    }
}
export default GraficaCalificaciones;
